import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Check, Sparkles } from "lucide-react";

const INCLUDES = [
  "Unlimited products, orders and customers",
  "Studio Advisor product generator",
  "Affiliate program & commissions",
  "Custom domain + SEO storefront",
  "Pulls from your Vault & Growth Engine",
];

export const MzPricing = ({ annual, setAnnual, url }) => {
  const price = annual ? "$39" : "$49";
  const cadence = annual ? "/mo · billed $470/yr" : "/mo · month-to-month";
  return (
    <section className="py-20 sm:py-28" id="pricing">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl mx-auto mb-12 sm:mb-14"
        >
          <p className="mz-eyebrow mb-3">One price · Everything included</p>
          <h2 className="mz-h text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tighter">
            One plan. <span className="mz-gold-text">No feature gates.</span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="max-w-lg mx-auto rounded-[2rem] p-[1.5px] shadow-[0_30px_80px_rgba(212,175,55,0.22)]"
          style={{ background: "linear-gradient(140deg, #BF953F, #FCF6BA 40%, #B38728)" }}
        >
          <div className="rounded-[calc(2rem-1.5px)] bg-white p-8 sm:p-10">
            <p className="mz-eyebrow text-center">Monetization Hub</p>

            <div className="mt-6 flex justify-center" role="group" aria-label="Billing cadence">
              <div className="inline-flex rounded-full border border-neutral-200 p-1 bg-[#FAFAFA]">
                <button
                  type="button"
                  onClick={() => setAnnual(false)}
                  data-testid="mn-mkt-monthly"
                  aria-pressed={!annual}
                  className={`rounded-full px-4 py-2 text-[12px] font-semibold transition-colors ${
                    !annual ? "mz-gold-fill text-[#1a1206]" : "text-neutral-500"
                  }`}
                >
                  Monthly · $49
                </button>
                <button
                  type="button"
                  onClick={() => setAnnual(true)}
                  data-testid="mn-mkt-annual"
                  aria-pressed={annual}
                  className={`rounded-full px-4 py-2 text-[12px] font-semibold transition-colors ${
                    annual ? "mz-gold-fill text-[#1a1206]" : "text-neutral-500"
                  }`}
                >
                  Annual · $39/mo
                </button>
              </div>
            </div>

            <div className="mt-8 text-center" data-testid="pricing-price">
              <span className="mz-h text-6xl sm:text-7xl font-bold mz-gold-text tracking-tighter">{price}</span>
              <p className="mt-2 text-[12px] text-neutral-400 font-medium">{cadence}</p>
            </div>

            <ul className="mt-8 space-y-3.5 max-w-xs mx-auto">
              {INCLUDES.map((f) => (
                <li key={f} className="flex items-start gap-3 text-[13px] text-neutral-600">
                  <span className="mz-gold-fill w-5 h-5 rounded-full flex items-center justify-center shrink-0 mt-0.5">
                    <Check size={11} className="text-[#1a1206]" strokeWidth={3} />
                  </span>
                  {f}
                </li>
              ))}
            </ul>

            <a href={url} data-testid="mn-mkt-cta" className="mz-btn-gold w-full mt-9 !py-4">
              <Sparkles size={14} strokeWidth={2} />
              Enable the Hub
              <ArrowUpRight size={14} strokeWidth={2.2} />
            </a>
            <p className="mt-4 text-center text-[11.5px] text-neutral-400">
              One-click Stripe checkout. Access the moment payment clears.
            </p>
            <p className="mt-2 text-center">
              <Link to="/pricing" className="text-[12px] font-semibold text-[#AA771C] hover:text-[#8a6b12] transition-colors">
                See all GoldKey plans →
              </Link>
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
